import { memo, useState, useEffect } from "react";

export const PlaylistItem = memo(({ video, index, isActive, onSelect, getThumbnailColor, getFileUrl }) => {
  const [thumbnailUrl, setThumbnailUrl] = useState(null);
  const [thumbnailLoading, setThumbnailLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    let objectUrl = null;

    const loadThumbnail = async () => {
      if (video.thumbnailToken && isMounted) {
        const url = await getFileUrl(video.thumbnailToken);
        if (isMounted) {
          objectUrl = url;
          setThumbnailUrl(url);
        }
      }
      if (isMounted) {
        setThumbnailLoading(false);
      }
    };

    loadThumbnail();

    return () => {
      isMounted = false;
      if (objectUrl && objectUrl.startsWith("blob:")) {
        window.URL.revokeObjectURL(objectUrl);
      }
    };
  }, [video.thumbnailToken, getFileUrl]);

  return (
    <div
      className={`relative flex gap-3 p-3 cursor-pointer transition-all duration-200 items-center ${
        isActive ? "bg-[#e9f1e8]" : "hover:bg-[#e9f1e860]"
      }`}
      onClick={() => onSelect(video.id)}
    >
      <div className="relative flex-shrink-0 w-20 h-14 rounded overflow-hidden">
        {thumbnailLoading ? (
          <div className="w-full h-full bg-gray-200 animate-pulse flex items-center justify-center">
            <span className="text-xs text-gray-400">Loading...</span>
          </div>
        ) : thumbnailUrl ? (
          <img
            src={thumbnailUrl}
            alt={video.filename}
            className="w-full h-full object-cover transition-opacity duration-200"
            onError={(e) => {
              e.target.style.display = "none";
              e.target.parentElement.querySelector(".gradient-fallback").style.display = "block";
            }}
          />
        ) : null}
        <div
          className={`gradient-fallback absolute inset-0 w-full h-full bg-gradient-to-br ${getThumbnailColor(
            index
          )} ${thumbnailUrl ? "hidden" : ""}`}
        />
        <div className="absolute bottom-1 right-1 bg-black/80 text-white text-xs px-1 py-0.5 rounded text-[10px]">
          {video.duration}
        </div>
      </div>
      <div className="flex-1 min-w-0">
        <h4 className="font-medium text-sm text-gray-900 truncate">
          {video.title}
        </h4>
        <p className="text-xs text-gray-500 mt-0.5 truncate">
          {(video.size / 1024 / 1024).toFixed(2)} MB
        </p>
      </div>
    </div>
  );
});

PlaylistItem.displayName = "PlaylistItem";
